import React, { useEffect, useState, Fragment } from "react";
import "../src/Styles/Pages/pmorderprocessing.scss";
import withAppData from "../src/HOC/withAppData";
import SinglePage from "../src/Layout/SinglePage";
import Loading from "../src/Loaders/Loading";
import { _capitalizeText, _formatCurrency, idempotencyKey } from "../src/Utils/helpers";
import { GET, POST } from "../src/Utils/api";
//import DriverReconManager from "./DriverReconManager";
import DriverReconStock from "./DriverReconStock";
import DriverReconPayment from "./DriverReconPayment";
import DriverReconUploadProof from "./DriverReconUploadProof";
import axios from "axios";
import { host_url } from "../src/app-config";

const PmShipmentReconcilationDetails = (props) => {
  const [driverReconcilationDetails, setDriverReconcilationDetails] = useState({
    itemDetails: [],
  });
  const [totalVirtualAmount, setTotalVirtualAmount] = useState(0);
  const [totalDriverVaBalance, setTotalDriverVaBalance] = useState(0);
  const [driverDetails, setDriverDetails] = useState([]);
  const [retailerDetails, setRetailerDetails] = useState([]);
  //const [getOnePipeAccountDetail, setGetOnePipeAccountDetail] = useState([]);
  const [driverVirtualAmount, setDriverVirtualAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [totalSkus, setTotalSkus] = useState(0);
  const [totalOutstanding, setTotalOutstanding] = useState(0);
  const [isRequired, setIsRequired] = useState(false);
  //const [isStockReconciled, setIsStockReconciled] = useState(0);
  const [formData, setFormData] = useState({
    stepNo: props.shipmentDetails.isProcessed === 0 ? 1 : 2,
    header: `Shipment ${props.shipmentDetails.shipmentId}`,
    buttonText: props.shipmentDetails.isProcessed === 0 ? "Reconcile" : "Next",
    backAction: () => {
      props.setShowReconcilation(false, props.activeTabIndex);
    },
    proof: {
      amount: null,
      image: null,
      driverDeposit: 0,
      driverCash: 0,
    },
  });
  useEffect(() => {
    props.shipmentDetails && GetDriverOnePipeBalance();
    GetDriverReconcilationDetails();
    //getOnePipeAccountDetails();
  }, []);
  const sumbitButtonAction = async (flag) => {
    //flag=0 for back and 1 for next
    let switchValue = flag === 1 ? formData.stepNo + 1 : formData.stepNo - 1;
    switch (switchValue) {
      case 1:
        setFormData((prevState) => ({
          ...prevState,
          stepNo: 1,
          header: `Shipment ${(
            props.shipmentDetails.shipmentId || ""
          ).toUpperCase()}`,
          buttonText: "Reconcile",
        }));
        setIsRequired(false);
        break;
      // case 2:
      // 	if (flag === 0 && props.shipmentDetails.isProcessed === 1) {
      // 		props.setShowReconcilation(false, props.activeTabIndex);
      // 	} else {
      // 		setFormData(prevState => ({
      // 			...prevState,
      // 			stepNo: 2,
      // 			header: "Choose Reconcilation Manager",
      // 			buttonText: "Next",
      // 		}));
      // 		setIsRequired( true);
      // 	}
      // 	break;
      case 2:
        if (flag === 0 && props.shipmentDetails.isProcessed === 1) {
          props.setShowReconcilation(false, props.activeTabIndex);
        } else {
          setFormData((prevState) => ({
            ...prevState,
            stepNo: 2,
            header: "Reconcile Stock",
            buttonText: "Next",
          }));
          setIsRequired(false);
        }
        break;
      case 3:
        setFormData((prevState) => ({
          ...prevState,
          stepNo: 3,
          header: "Enter Payment",
          buttonText: "Next",
        }));
        setIsRequired(true);
        break;
      case 4:
        await uploadProof();
        setFormData((prevState) => ({
          ...prevState,
          stepNo: 4,
          header: "Reconcile Payments",
          buttonText: "Close",
        }));

        setIsRequired(hasPendingPayment());
        break;
      default: // to avoid it being called on back button
        flag !== 0 && (await updateReconcilationManager());
        props.setShowReconcilation(false, props.activeTabIndex);
        switchValue === 4 && props.context.showAlert("Succcessfully");
    }
  };
  // const AssignReconcilationManager = async () => {
  // 	if (selectedManagerId === 0) {
  // 		props.context.showAlert("Please choose the assign manager", "error");
  // 	} else {
  // 		setIsLoading(true);
  // 		let data = {
  // 			ShipmentId: props.shipmentDetails.shipmentId,
  // 			recoManagerUserId: selectedManagerId,
  // 			shipmentStatusID: 6,
  // 		};
  // 		const result = await POST(
  // 			"PickerShipment/AssignReconcilationManager",
  // 			data,
  // 		);
  // 		if (result.error) {
  // 			setIsLoading(false);
  // 			props.context.showAlert(
  // 				result.error.errorCode === 2
  // 					? "The trip has not stopped so reco manager cannot be assigned"
  // 					: result.error.errorCode === 3
  // 					? "Only one Shipment can be requested for Reconciliation at a time"
  // 					: "Unable to assign manager. Please try again",
  // 				"error",
  // 			);
  // 		} else {
  // 			props.context.showAlert("Assigned to manager successfully");
  // 			await GetDriverReconcilationDetails();
  // 			setFormData({
  // 				stepNo: 3,
  // 				header: "Reconcile Stock",
  // 				buttonText: "Next",
  // 			});
  // 			setIsRequired(false);
  // 			setIsLoading(false);
  // 		}
  // 	}
  // };
  const GetDriverOnePipeBalance = async () => {
    setIsLoading(true);
    const result = await GET(
      `payment/GetOnePipeBalanceForDriver?customerId=${props.shipmentDetails.driverId}`
    );
    if (!result.error) {
      setDriverVirtualAmount(result.amount);
      getPaymentSummery(result.amount);
      setIsLoading(false);
    } else {
      setIsLoading(false);
      getPaymentSummery(0);
    }
  };
  const GetDriverReconcilationDetails = async () => {
    setIsLoading(true);
    const result = await GET(
      `PickerShipment/GetDriverReconcilation?shipmentID=${props.shipmentDetails.shipmentId}`
    );
    const bankPaymentAmountResult = await GET(
      `PickerShipment/GetBankTransferAmountByShipmentId?shipmentId=${props.shipmentDetails.shipmentId}`
    );

    const outstandingBalResult = await GET(
      `PickerShipment/GetUserOutstandingBalance?agentID=${props.context.userId}&shipmentId=${props.shipmentDetails.shipmentId}`
    );

    const resultObject = result.ReconcilationDetails
      ? result.ReconcilationDetails[0] || {}
      : {};
    let recoDetails = {};

    // if (result && result.ReconcilationDetails) {
    //   setIsStockReconciled(result.ReconcilationDetails[0].isStockReconciled);
    // }

    if (
      !outstandingBalResult.error &&
      outstandingBalResult.userOutstandingBalance
    ) {
      setTotalOutstanding(
        outstandingBalResult.userOutstandingBalance[0].totalOutstanding || 0
      );
      recoDetails = {
        ...resultObject,
        previousOutstanding:
          outstandingBalResult.userOutstandingBalance[0].previousOutstanding ||
          0,
        outstandingLimit:
          outstandingBalResult.userOutstandingBalance[0].outstandingLimit || 0,
        deliveriesValue:
          (resultObject.deliveriesValue || 0) - (resultObject.discount || 0),
        previousExcess : outstandingBalResult.userOutstandingBalance[0].previousExcess || 0,
      };
      setDriverReconcilationDetails(recoDetails);
      setTotalSkus(result.totalSkus || 0);
    }
    if (
      !result.error &&
      !bankPaymentAmountResult.error &&
      result.ReconcilationDetails
    ) {
      recoDetails = {
        ...recoDetails,
        bankTransferAmount: bankPaymentAmountResult.BankTransfer || 0,
        deliveriesValue:
          (resultObject.deliveriesValue || 0) - (resultObject.discount || 0),
        cod: bankPaymentAmountResult.COD || 0,
        incompleteBankTransfer: bankPaymentAmountResult.IncompleteBankTransfer,
        completedBankTransfer: bankPaymentAmountResult.BankTransfer || 0,
        totalBankTransfer:
          (bankPaymentAmountResult.BankTransfer || 0) +
          (bankPaymentAmountResult.IncompleteBankTransfer || 0),
        totalOnepipeConfirmed: parseInt(
          bankPaymentAmountResult.TotalOnepipeConfirmedAmount || 0,
          10
        ),
        rto: resultObject.rto || 0,
        incompletedPayment: bankPaymentAmountResult.IncompletedPayment || 0,
      };
      setDriverReconcilationDetails(recoDetails);
      setTotalSkus(result.totalSkus || 0);
    } else {
      setIsLoading(false);
    }
  };

  const onUploadProofValidate = (valid, paymentProofData) => {
    setFormData({
      ...formData,
      proof: paymentProofData,
    });
    const driversDeposit = paymentProofData
      ? parseInt(paymentProofData.driverDeposit, 10)
      : 0;
    const driverCash = paymentProofData
      ? parseInt(paymentProofData.driverCash, 10)
      : 0;
    setDriverReconcilationDetails((recoDetails) => ({
      ...recoDetails,
      cashCollected:
        isNaN(driverReconcilationDetails.cod) || isNaN(driversDeposit)
          ? 0
          : parseInt(driverReconcilationDetails.cod - driversDeposit, 10),
      driverDeposit: isNaN(driversDeposit) ? 0 : parseInt(driversDeposit, 10),
      driverCash: isNaN(driverCash) ? 0 : parseInt(driverCash, 10),
      collectedByCash: driverReconcilationDetails.cod,
      newOutstanding:
				(driverReconcilationDetails.deliveriesValue || 0) +
				(driverReconcilationDetails.resellValue || 0) +
				(driverReconcilationDetails.currentStockOutstanding || 0) -
				((driverReconcilationDetails.rto || 0) +
					(driverCash || 0) +
					(driversDeposit || 0) +
					(driverReconcilationDetails.PayLaterAmount || 0) +
					(driverReconcilationDetails.completedOnePipeAmount || 0) +
					(driverReconcilationDetails.previousExcess || 0) + 
					(driverVirtualAmount || 0)
					),
		}));
    setIsRequired(!valid);
  };

  const uploadProof = async () => {
    setIsLoading(true);
    const amount =
      formData && formData.proof && formData.proof.amount
        ? !isNaN(formData.proof.amount)
          ? parseInt(formData.proof.amount, 10)
          : 0
        : 0;
    const driverDeposit =
      formData && formData.proof && formData.proof.driverDeposit
        ? !isNaN(formData.proof.driverDeposit)
          ? parseInt(formData.proof.driverDeposit, 10)
          : 0
        : 0;
    const driverCash =
      formData && formData.proof && formData.proof.driverCash
        ? !isNaN(formData.proof.driverCash)
          ? parseInt(formData.proof.driverCash, 10)
          : 0
        : 0;
    const existingFiles = [];
    const imageData = new FormData();
    formData.proof &&
      formData.proof.images &&
      formData.proof.images.forEach((img, index) => {
        if (img.file) {
          imageData.append(`image${index}`, img.file);
        } else {
          existingFiles.push(img.url);
        }
      });
    imageData.append("amount", amount);
    imageData.append("driverDeposit", driverDeposit);
    imageData.append("driverCash", driverCash);
    imageData.append("shipmentId", props.shipmentDetails.shipmentId);
    imageData.append("existingImages", JSON.stringify(existingFiles));
    imageData.append(
      "completedBankTransferAmount",
      driverReconcilationDetails.bankTransferAmount || 0
    );
    imageData.append(
      "totalBankPayment",
      driverReconcilationDetails.totalBankTransfer || 0
    );
    imageData.append(
      "totalOrderValue",
      driverReconcilationDetails.deliveriesValue || 0
    );
    imageData.append("rto", driverReconcilationDetails.rto || 0);
    await POST("PickerShipment/SubmitCODProof", imageData);
    setIsLoading(false);
  };

  const updateReconcilationManager = async () => {
		const data = {
			customerID: props.shipmentDetails.driverId,
			amountCollected: driverReconcilationDetails.amountCollected,
			outstandingBalance: driverReconcilationDetails.newOutstanding,
			currentStockOutstanding: driverReconcilationDetails.remaining || 0,
			shipmentStatusId: props.shipmentDetails.shipmentStatusId,
			shipmentId: props.shipmentDetails.shipmentId,
			driverStockReconcilationDetails:
				driverReconcilationDetails.itemDetails || [],
			isFromReconcilation: true,
			IdempotencyKey:
				props.shipmentDetails.driverId +
				props.shipmentDetails.shipmentId +
				idempotencyKey(),
		};
		setIsLoading(true);
		const response = await POST(
			"PickerShipment/ConfirmDriverReconcilation",
			data,
		);
		if (!response.error) {
			props.context.isDepot && (await uploadDriverSellInvoice());
			// checking the status of shipment assigned to sco or finance -- Bhupender
			GetShipmentAssignmentStatus();
		} else {
			props.context.showAlert(response.error.message, "error");
		}
		// onepipeCollectAndDisburse();
		// finalDisburseCall();

		//setIsLoading(false);
	};
	const GetShipmentAssignmentStatus = async () => {
		const result = await GET(
			`PickerShipment/GetShipmentAssignmentStatus?shipmentId=${props.shipmentDetails.shipmentId}`,
		);
		if (!result.error) {
			if (result && result.sco === 1) {
				ShipmentAssignSCO();
			} else if (result && result.finance === 1) {
				ShipmentAssignRecoManager();
			} else {
				setIsLoading(false);
				console.log(
					`Still shipment ${props.shipmentDetails.shipmentId} is not assigned to any one.`,
				);
			}
		}
	};

  // const finalDisburseCall = async () => {
	// 	if (
	// 		driverReconcilationDetails &&
	// 		driverVirtualAmount > 0 &&
	// 		driverReconcilationDetails.isProcessed === 7 &&
	// 		totalOutstanding > 0 &&
	// 		props.shipmentDetails.shipmentId !== undefined
	// 	) {
	// 		if (driverVirtualAmount >= totalOutstanding) {
	// 			callOnepipeCollect(
	// 				props.shipmentDetails.driverId,
	// 				totalOutstanding,
	// 				props.shipmentDetails.shipmentId,
	// 			);
	// 		} else {
	// 			callOnepipeCollect(
	// 				props.shipmentDetails.driverId,
	// 				driverVirtualAmount,
	// 				props.shipmentDetails.shipmentId,
	// 			);
	// 		}
	// 	}
	// };

  // const getOnePipeAccountDetails = async () => {
  // 	const getOnePipeAccount = await GET(
  // 		`payment/GetOnePipeAccountDetails?shipmentId=${props.shipmentDetails.shipmentId}`,
  // 	);
  // 	if (!getOnePipeAccount.error) {
  // 		setGetOnePipeAccountDetail(getOnePipeAccount);
  // 	}
  // };

  const onepipeCollectAndDisburse = () => {
		let totalCollectAmount = 0;

		let totalOrderAmount =
			(driverReconcilationDetails.Total || 0) +
			(driverReconcilationDetails.discount || 0) +
			(driverReconcilationDetails.resellValue || 0);
		let totalDiscount =
			(driverReconcilationDetails.rto || 0) +
			(driverReconcilationDetails.discount || 0) +
			(driverReconcilationDetails.previousExcess || 0) +
			(driverReconcilationDetails.amountCollected || 0);

		// getOnePipeAccountDetail &&
		// 	getOnePipeAccountDetail.forEach(data => {
		// 		if (data.amount > 0) {
		// 			totalDiscount = totalDiscount + data.amount;
		// 		}
		// 	});
		totalCollectAmount = totalOrderAmount - totalDiscount;
		if (driverVirtualAmount > 0 && totalCollectAmount > 0) {
			if (driverVirtualAmount < totalCollectAmount) {
				callOnepipeCollect(props.shipmentDetails.driverId, driverVirtualAmount);
			} else {
				callOnepipeCollect(props.shipmentDetails.driverId, totalCollectAmount);
			}
		}
		// else {
		// 	UpdatePaymentStatusForReco();
		// }
	};

  // const UpdatePaymentStatusForReco = async () => {
  // 	const data = {
  // 		shipmentId: props.shipmentDetails.shipmentId,
  // 		driverVirtualAmount: 0,
  // 	};
  // 	setIsLoading(true);
  // 	const response = await POST("payment/UpdatePaymentStatusForReco", data);
  // 	if (response.error) {
  // 		props.context.showAlert(response.error.message, "error");
  // 	}
  // };

  const callOnepipeCollect = (customerId, amount) => {
		let error = 0;
		const deliveryValue = driverReconcilationDetails.deliveriesValue;
		const collectedValue =
			(driverReconcilationDetails.driverCash || 0) +
			(driverReconcilationDetails.driverDeposit || 0) +
			(totalVirtualAmount || 0);
		let url = `${host_url}payment/OnePipeCollect?customerId=${customerId}&amount=${amount}&shipmentId=${props.shipmentDetails.shipmentId}
		&totalShipmentAmount=${deliveryValue}&totalAmountCollected=${collectedValue}`;
		try {
			axios.get(url, props.context.jsonHeader).then(response => {
				if (response.data.StatusCode === 1) {
					error = 1;
					console.log(
						`amount  ${amount} collected successfully for this user ${customerId}`,
					);
				} else {
					console.log(
						`Error- amount  ${amount} Not collected for this user ${customerId}`,
					);
				}
			});
		} catch (error) {
			console.log(`Got error in collect  ${url} Error- ` + error);
		}
		return error;
	};

  const getPaymentSummery = async amount => {
		const result = await GET(
			`payment/GetPaymentDetailsByShipmentId?shipmentId=${props.shipmentDetails.shipmentId}`,
		);
		if (!result.error) {
			const driverDetail = driverDetails;
			const retailerDetail = retailerDetails;
			let TotalAmount = 0;
			result &&
				result.Retailer &&
				result.Retailer.map(item => {
					retailerDetail.push(item.amount);
					TotalAmount = TotalAmount + item.amount;
					return {
						TotalAmount,
					};
				});

			result &&
				result.Driver &&
				result.Driver.map(item => {
					if (item.amount > 0) {
						driverDetail.push(item.amount);
						TotalAmount = TotalAmount + item.amount;
					}
					return {
						TotalAmount,
					};
				});

			driverDetail.push(amount);
			setTotalDriverVaBalance(amount);
			setTotalVirtualAmount(TotalAmount);
			setDriverDetails(driverDetail);
			setRetailerDetails(retailerDetail);
		}
	};

  const ShipmentAssignSCO = async () => {
		const data = {
			shipmentId: props.shipmentDetails.shipmentId,
		};
		setIsLoading(true);
		const response = await POST("DriverRtoSell/ShipmentAssignSCO", data);
		if (!response.error) {
			setIsLoading(false);
			props.context.showAlert(
				"Stock manager Name - " + response.StockManagerName,
				"Success",
			);
		} else {
			setIsLoading(false);
			props.context.showAlert(response.error.message, "error");
		}
	};
	const ShipmentAssignRecoManager = async () => {
		const data = {
			shipmentId: props.shipmentDetails.shipmentId,
		};
		setIsLoading(true);
		const response = await POST(
			"DriverRtoSell/ShipmentAssignRecoManager",
			data,
		);
		if (!response.error) {
			setIsLoading(false);
			props.context.showAlert(
				"Reco manager Name - " + response.RecokManagerName,
				"Success",
			);
		} else {
			//props.isStockConfirm(false);
			setIsLoading(false);
			props.context.showAlert(response.error.message, "error");
		}
	};

  const hasPendingPayment = () => driverReconcilationDetails.newOutstanding > 0;

  return (
    <SinglePage
      width="650px"
      margin="0 auto"
      heading={formData.header}
      isFixedHeight={true}
      backAction={() => sumbitButtonAction(0)}
      buttonText={formData.buttonText}
      buttonAction={() => sumbitButtonAction(1)}
      buttonDisabled={isLoading || (isLoading === false && isRequired)}
    >
      {isLoading ? (
        <Loading />
      ) : formData.stepNo === 1 ? (
        <Fragment>
          <div className="pm-driver-recon-card">
            <div className="pm-driver-recon-card-header panel">
              <p>
                Showing <span> {totalSkus} </span> SKUs
              </p>
            </div>
            <div className="pm-driver-recon-card-body">
              <div className="pm-driver-recon-card-subheader panel">
                <div>
                  <p>
                    Picked Qty:{" "}
                    <span>{driverReconcilationDetails.picked || 0}</span>ctn{" "}
                  </p>
                  <p>
                    Value:{" "}
                    <span>
                      {_formatCurrency(driverReconcilationDetails.value || 0)}
                    </span>
                  </p>
                </div>
                <div>
                  <p>
                    Remaining Qty:{" "}
                    <span>{driverReconcilationDetails.remaining || 0}</span>ctn{" "}
                  </p>
                  <p>
                    Remaining Value:{" "}
                    <span>
                      {_formatCurrency(
                        driverReconcilationDetails.remainingValue || 0
                      )}
                    </span>
                  </p>
                </div>
                <div>
                  <p>
                    ReSell Qty:{" "}
                    <span>{driverReconcilationDetails.resellQty || 0}</span>ctn{" "}
                  </p>
                  <p>
                    ReSell Value:{" "}
                    <span>
                      {_formatCurrency(
                        driverReconcilationDetails.resellValue || 0
                      )}
                    </span>
                  </p>
                </div>
              </div>
              {(!!driverReconcilationDetails.itemDetails
                ? driverReconcilationDetails.itemDetails
                : []
              ).map((item, index) => (
                <div className="package-manager-module" key={index}>
                  <div className="panel stock-card">
                    <div className="stock-card-name">
                      {_capitalizeText(item.itemName)}
                    </div>
                    <div
                      className="stock-card-action flex align-center flex-between "
                      style={{ marginTop: "20px" }}
                    >
                      <div>
                        {item.picked} <span className="light"> picked </span>
                      </div>
                      <div className="stock-card-action flex flex-between">
                        {/* <div>
													{item.picked} <span className="light"> picked </span>
												</div> */}
                        <div>
                          {item.remaining}{" "}
                          <span className="light"> remaining </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Fragment>
      ) : // : formData.stepNo === 2 ? (
      //   <DriverReconManager
      //     setIsRequired={setIsRequired}
      //     setSelectedManagerId={setSelectedManagerId}
      //     selectedManagerId={selectedManagerId}
      //   />
      // )
      formData.stepNo === 2 ? (
        <DriverReconStock
          driverReconcilationDetails={driverReconcilationDetails}
        />
      ) : formData.stepNo === 3 ? (
        <DriverReconUploadProof
          driverId = {props.shipmentDetails.driverId}
          newDriverVirtualBalance = {driverVirtualAmount}
          totalVirtualAmount={totalVirtualAmount}
          totalDriverVaBalance={totalDriverVaBalance}
          driverDetails={driverDetails}
          retailerDetails={retailerDetails}
          driverVirtualAmount={driverVirtualAmount}
          shipmentId={props.shipmentDetails.shipmentId}
          driverReconcilationDetails={driverReconcilationDetails}
          validateModel={(valid, paymentProof) =>
            onUploadProofValidate(valid, paymentProof)
          }
        />
      ) : (
        <DriverReconPayment
          driverReconcilationDetails={driverReconcilationDetails}
          shipmentId={props.shipmentDetails.shipmentId || ""}
          driverVirtualAmount={driverVirtualAmount}
          totalVirtualAmount={totalVirtualAmount}
        />
      )}
    </SinglePage>
  );
};

export default withAppData(PmShipmentReconcilationDetails);
